// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Hotels page — small additions on top of allFacility.css */

.ht-filter-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  color: var(--bv-primary);
  font-size: 1rem;
}

.af-sidebar__filter.is-active .ht-filter-icon {
  color: var(--bv-primary-700);
}

.ht-card-tag .ht-filter-icon {
  font-size: 0.7rem;
}

.ht-card-rating {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 6px 10px;
  border-radius: var(--bv-radius-pill);
  background: rgba(15, 23, 42, 0.72);
  color: #fff;
  font-family: var(--bv-font-display);
  font-size: var(--bv-text-xs);
  font-weight: 700;
  backdrop-filter: blur(6px);
}

.ht-card-rating i {
  color: #facc15;
  font-size: 0.7rem;
}

/* Hotel detail extras (on top of facilityDetail.css) */
.ht-hero-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.ht-hero-eyebrow i {
  color: var(--bv-primary);
}

.ht-about-meta {
  list-style: none;
  margin: var(--bv-space-4) 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ht-about-meta li {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: var(--bv-text-sm);
  color: var(--bv-muted);
  font-weight: 500;
}

.ht-about-meta li i {
  color: var(--bv-primary);
  width: 1rem;
  text-align: center;
}

.ht-guest-chip-icon {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  color: var(--bv-primary);
}

.fv-activity-chip.is-selected .ht-guest-chip-icon {
  color: var(--bv-primary-700);
}

.ht-nights-hint {
  margin: var(--bv-space-3) 0 0;
  font-size: var(--bv-text-xs);
  color: var(--bv-muted);
  line-height: 1.45;
}
`, "",{"version":3,"sources":["webpack://./src/css/hotels.css"],"names":[],"mappings":"AAAA,4DAA4D;;AAE5D;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,kCAAkC;EAClC,WAAW;EACX,mCAAmC;EACnC,4BAA4B;EAC5B,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,uDAAuD;AACvD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,4BAA4B;EAC5B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,sBAAsB;EACtB,iBAAiB;AACnB","sourcesContent":["/* Hotels page — small additions on top of allFacility.css */\n\n.ht-filter-icon {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  color: var(--bv-primary);\n  font-size: 1rem;\n}\n\n.af-sidebar__filter.is-active .ht-filter-icon {\n  color: var(--bv-primary-700);\n}\n\n.ht-card-tag .ht-filter-icon {\n  font-size: 0.7rem;\n}\n\n.ht-card-rating {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 6px 10px;\n  border-radius: var(--bv-radius-pill);\n  background: rgba(15, 23, 42, 0.72);\n  color: #fff;\n  font-family: var(--bv-font-display);\n  font-size: var(--bv-text-xs);\n  font-weight: 700;\n  backdrop-filter: blur(6px);\n}\n\n.ht-card-rating i {\n  color: #facc15;\n  font-size: 0.7rem;\n}\n\n/* Hotel detail extras (on top of facilityDetail.css) */\n.ht-hero-eyebrow {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ht-hero-eyebrow i {\n  color: var(--bv-primary);\n}\n\n.ht-about-meta {\n  list-style: none;\n  margin: var(--bv-space-4) 0 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.ht-about-meta li {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-size: var(--bv-text-sm);\n  color: var(--bv-muted);\n  font-weight: 500;\n}\n\n.ht-about-meta li i {\n  color: var(--bv-primary);\n  width: 1rem;\n  text-align: center;\n}\n\n.ht-guest-chip-icon {\n  display: inline-flex !important;\n  align-items: center;\n  justify-content: center;\n  color: var(--bv-primary);\n}\n\n.fv-activity-chip.is-selected .ht-guest-chip-icon {\n  color: var(--bv-primary-700);\n}\n\n.ht-nights-hint {\n  margin: var(--bv-space-3) 0 0;\n  font-size: var(--bv-text-xs);\n  color: var(--bv-muted);\n  line-height: 1.45;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
